import { ShareModel, baseConfigParams, ExtTokenStoreParams } from '@/models/share';
import qs from 'querystring';
import { appendParam } from '@/common/util/url';
import nanoid from 'nanoid';
export interface ShareType {
    name: string;
    text: string;
    logName: string;
    shareChannel: string;
    url: (query: Partial<CardShareParam>, shareId: string) => string;
}

interface CardShareParam {
    url: string;
    title: string;
    source: string;
    description: string;
    summary: string;
    image: string;
}

export const SHARE_TYPES: ShareType[] = [
    {
        name: 'qq',
        text: 'QQ',
        logName: 'QQ',
        shareChannel: 'QQ',
        url: ({
            url,
            title,
            source,
            image,
            summary,
        }: Partial<CardShareParam>, shareId: string) => {
            const query = {
                url: appendParam(url as string, {
                    share_channel: 'QQ',
                    share_id: shareId,
                }),
                title,
                source,
                pics: image,
                summary,
            };
            return `http://connect.qq.com/widget/shareqq/index.html?${qs.stringify(query)}`;
        },
    },
    {
        name: 'qzone',
        text: 'QQ空间',
        logName: 'QQZOOM',
        shareChannel: 'QZone',
        url: ({
            url,
            title,
            source,
            description,
            summary,
            image,
        }: Partial<CardShareParam>, shareId: string) => {
            const query = {
                url: appendParam(url as string, {
                    share_channel: 'QQZOOM',
                    share_id: shareId,
                }),
                title,
                desc: description,
                summary,
                site: source,
                pics: image,
            };
            return `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?${qs.stringify(query)}`;
        },
    },
    {
        name: 'weibo',
        text: '微博',
        logName: 'MICROBLOG',
        shareChannel: 'WEIBO',
        url: ({ url, title, image }: Partial<CardShareParam>, shareId: string) => {
            const query = {
                url: appendParam(url as string, {
                    share_channel: 'MICROBLOG',
                    share_id: shareId,
                }),
                title,
                pic: image,
            };
            return `https://service.weibo.com/share/share.php?${qs.stringify(query)}`;
        },
    },
];

async function getShareLink({
    shareId,
    shareModel,
    shareType,
    id,
    shareInfo,
    shareConfig,
}: {
    shareId: string,
    shareModel: ShareModel,
    shareType: ShareType,
    id: string,
    shareInfo: ExtTokenStoreParams,
    shareConfig: baseConfigParams,
}) {
    await shareModel.handleCardShare({ shareId: id, shareChannel: shareType.shareChannel, shareInfo, config: shareConfig });
    return shareType.url(shareModel.cardShareObj, shareId);
}
export async function useCardShare({
    shareType,
    shareModel,
    log,
    id,
    shareInfo,
    shareConfig,
    logType,
}: {
    shareType: ShareType,
    shareModel: ShareModel,
    log: Function,
    id: string,
    shareInfo: ExtTokenStoreParams,
    shareConfig: baseConfigParams,
    logType?: string
}) {
    const shareId = nanoid();
    window.open(await getShareLink({ shareId, shareModel, shareType, id, shareInfo, shareConfig }), '_blank');
    log({
        type: 'CLICK',
        event_name: 'SHARE_TOOL_BUTTON',
        logType,
        event_value: {
            tool_name: shareType.logName,
            share_id: shareId,
        },
    });
}

export function useCopyTokenLog(log: Function, logType?: string) {
    const shareId = nanoid();
    log({
        type: 'CLICK',
        event_name: 'SHARE_COPY_BUTTON',
        logType,
        event_value: {
            share_id: shareId,
        },
    });
}
